<script setup lang="ts">
  import { onUnmounted, toRef } from "vue";
  import { storeToRefs } from "pinia";
  import { Spinner } from "@/components/ui/spinner";
  import ReviewCard from "@/components/Survey/Review/ReviewPane/ReviewCard/ReviewCard.vue";
  import { useSurveyCardsStore } from "@stores/survey/surveyCards";
  import { useSurveySectionsStore } from "@stores/survey/surveySections";
  import { useReviewDocument } from "@utils/composables/reviewDocument";

  const { firstLoadReviewPage } = storeToRefs(useSurveyCardsStore());
  const { sections } = storeToRefs(useSurveySectionsStore());

  const props = defineProps<{
    cards: Array<Record<string, unknown>>;
    cardSubTypesInfos: Record<string, unknown>;
    cardTypesGroups: Array<Record<string, unknown>>;
  }>();

  const { entries } = useReviewDocument(toRef(props, "cards"), sections);

  onUnmounted(() => {
    firstLoadReviewPage.value = true;
  });
</script>

<template>
  <article
    data-cy="review-pane"
    class="flex w-full flex-col gap-3 pb-14">
    <Suspense>
      <template #default>
        <div class="flex flex-col gap-3">
          <template
            v-for="entry in entries"
            :key="entry.card.token">
            <h2
              v-if="entry.startsSection && entry.sectionName"
              class="mt-6 mb-1 px-1 text-lg font-semibold tracking-[-0.01em] text-primary first:mt-1">
              {{ entry.sectionName }}
            </h2>
            <ReviewCard
              :card="entry.card"
              :card-sub-types-infos="cardSubTypesInfos"
              :card-types-groups="cardTypesGroups" />
          </template>
        </div>
      </template>
      <template #fallback>
        <Spinner class="mx-auto my-2 size-6" />
      </template>
    </Suspense>
  </article>
</template>
